import { type MRT_Localization } from "material-react-table";

export const MRT_Localization_ML: MRT_Localization = {
  language: "ml",
  actions: "പ്രവർത്തനങ്ങൾ",
  and: "ഒപ്പം",
  cancel: "റദ്ദാക്കുക",
  changeFilterMode: "ഫിൽട്ടർ മോഡ് മാറ്റുക",
  changeSearchMode: "തിരയൽ മോഡ് മാറ്റുക",
  clearFilter: "ഫിൽട്ടർ മായ്ക്കുക",
  clearSearch: "തിരയൽ മായ്ക്കുക",
  clearSelection: "തിരഞ്ഞെടുപ്പ് മായ്ക്കുക",
  clearSort: "വർഗ്ഗീകരണം മായ്ക്കുക",
  clickToCopy: "കോപ്പി ചെയ്യാൻ ക്ലിക്ക് ചെയ്യുക",
  copy: "കോപ്പി",
  collapse: "ചുരുക്കുക",
  collapseAll: "എല്ലാം ചുരുക്കുക",
  columnActions: "കോളം പ്രവർത്തനങ്ങൾ",
  copiedToClipboard: "ക്ലിപ്പ്ബോർഡിലേക്ക് കോപ്പി ചെയ്തു",
  dropToGroupBy: "ഗ്രൂപ്പ് ചെയ്യാൻ {column} ലേക്ക് ഡ്രോപ്പ് ചെയ്യുക",
  edit: "എഡിറ്റ്",
  expand: "വികസിപ്പിക്കുക",
  expandAll: "എല്ലാം വികസിപ്പിക്കുക",
  filterArrIncludes: "ഉൾപ്പെടുത്തുന്നു",
  filterArrIncludesAll: "എല്ലാം ഉൾപ്പെടുത്തുന്നു",
  filterArrIncludesSome: "ഉൾപ്പെടുത്തുന്നു",
  filterBetween: "ഇടയിൽ",
  filterBetweenInclusive: "ഉൾപ്പെടുത്തിയ ഇടയിൽ",
  filterByColumn: "{column} ഉപയോഗിച്ച് ഫിൽട്ടർ ചെയ്യുക",
  filterContains: "ഉൾപ്പെടുത്തുന്നു",
  filterEmpty: "ശൂന്യം",
  filterEndsWith: "കൊണ്ട് അവസാനിക്കുന്നു",
  filterEquals: "സമം",
  filterEqualsString: "സമം",
  filterFuzzy: "ഫസ്സി",
  filterGreaterThan: "കൂടുതൽ",
  filterGreaterThanOrEqualTo: "കൂടുതൽ അല്ലെങ്കിൽ സമം",
  filterInNumberRange: "ഇടയിൽ",
  filterIncludesString: "ഉൾപ്പെടുത്തുന്നു",
  filterIncludesStringSensitive: "ഉൾപ്പെടുത്തുന്നു",
  filterLessThan: "കുറവ്",
  filterLessThanOrEqualTo: "കുറവ് അല്ലെങ്കിൽ സമം",
  filterMode: "ഫിൽട്ടർ മോഡ്: {filterType}",
  filterNotEmpty: "ശൂന്യമല്ല",
  filterNotEquals: "സമമല്ല",
  filterStartsWith: "കൊണ്ട് ആരംഭിക്കുന്നു",
  filterWeakEquals: "സമം",
  filteringByColumn:
    "{column} ഉപയോഗിച്ച് ഫിൽട്ടറിംഗ് - {filterType} {filterValue}",
  goToFirstPage: "ആദ്യ പേജിലേക്ക് പോകുക",
  goToLastPage: "അവസാന പേജിലേക്ക് പോകുക",
  goToNextPage: "അടുത്ത പേജിലേക്ക് പോകുക",
  goToPreviousPage: "മുമ്പത്തെ പേജിലേക്ക് പോകുക",
  grab: "പിടിക്കുക",
  groupByColumn: "{column} ഉപയോഗിച്ച് ഗ്രൂപ്പ് ചെയ്യുക",
  groupedBy: "ഉപയോഗിച്ച് ഗ്രൂപ്പ് ചെയ്തു ",
  hideAll: "എല്ലാം മറയ്ക്കുക",
  hideColumn: "{column} കോളം മറയ്ക്കുക",
  max: "പരമാവധി",
  min: "കുറഞ്ഞത്",
  move: "നീക്കുക",
  noRecordsToDisplay: "പ്രദർശിപ്പിക്കാൻ റെക്കോർഡുകളൊന്നുമില്ല",
  noResultsFound: "ഫലങ്ങളൊന്നും കണ്ടെത്തിയില്ല",
  of: "ന്റെ",
  or: "അല്ലെങ്കിൽ",
  pin: "പിൻ ചെയ്യുക",
  pinToLeft: "ഇടതുവശത്ത് പിൻ ചെയ്യുക",
  pinToRight: "വലതുവശത്ത് പിൻ ചെയ്യുക",
  resetColumnSize: "കോളം വലിപ്പം റീസെറ്റ് ചെയ്യുക",
  resetOrder: "ക്രമം റീസെറ്റ് ചെയ്യുക",
  rowActions: "വരി പ്രവർത്തനങ്ങൾ",
  rowNumber: "#",
  rowNumbers: "വരി നമ്പറുകൾ",
  rowsPerPage: "പേജിന് വരികൾ",
  save: "സേവ്",
  search: "തിരയുക",
  selectedCountOfRowCountRowsSelected:
    "{selectedCount} എന്നതിൽ {rowCount} വരി(കൾ) തിരഞ്ഞെടുത്തു",
  select: "തിരഞ്ഞെടുക്കുക",
  showAll: "എല്ലാം കാണിക്കുക",
  showAllColumns: "എല്ലാ കോളങ്ങളും കാണിക്കുക",
  showHideColumns: "കോളങ്ങൾ കാണിക്കുക/മറയ്ക്കുക",
  showHideFilters: "ഫിൽട്ടറുകൾ കാണിക്കുക/മറയ്ക്കുക",
  showHideSearch: "തിരയൽ കാണിക്കുക/മറയ്ക്കുക",
  sortByColumnAsc: "{column} ഉപയോഗിച്ച് ആരോഹണ ക്രമത്തിൽ സോർട്ട് ചെയ്യുക",
  sortByColumnDesc: "{column} ഉപയോഗിച്ച് അവരോഹണ ക്രമത്തിൽ സോർട്ട് ചെയ്യുക",
  sortedByColumnAsc: "{column} ഉപയോഗിച്ച് ആരോഹണ ക്രമത്തിൽ സോർട്ട് ചെയ്തു",
  sortedByColumnDesc: "{column} ഉപയോഗിച്ച് അവരോഹണ ക്രമത്തിൽ സോർട്ട് ചെയ്തു",
  thenBy: ", പിന്നെ ",
  toggleDensity: "സാന്ദ്രത ടോഗിൾ ചെയ്യുക",
  toggleFullScreen: "പൂർണ്ണ സ്ക്രീൻ ടോഗിൾ ചെയ്യുക",
  toggleSelectAll: "എല്ലാം തിരഞ്ഞെടുക്കുക ടോഗിൾ ചെയ്യുക",
  toggleSelectRow: "വരി തിരഞ്ഞെടുക്കുക ടോഗിൾ ചെയ്യുക",
  toggleVisibility: "ദൃശ്യത ടോഗിൾ ചെയ്യുക",
  ungroupByColumn: "{column} ഉപയോഗിച്ച് ഗ്രൂപ്പ് റദ്ദാക്കുക",
  unpin: "അൺപിൻ ചെയ്യുക",
  unpinAll: "എല്ലാം അൺപിൻ ചെയ്യുക",
};
